module.exports = __webpack_public_path__ + "media/images/img_yamada-46338253d2e2a0544210cee0bccd292e.jpg";